<template>
  <div style="max-width: 500px" class="mx-auto">
    <div class="Kanit primary pa-4 text-center white--text" style="font-size: 22px">
      แนบบัตรประชาชน
    </div>
    <div>
      <v-btn @click="$emit('close')" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="pa-5 pt-2">
      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="รูปบัตรประชาชน"
          v-slot="{ errors }"
        >
          <div class="grey--text pb-1">รูปบัตรประชาชน <span class="red--text"> *</span></div>
          <UploadSingleFile v-model="input.identityNumberImage" :errors="errors"></UploadSingleFile>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center">
        <v-btn :loading="saveloading" class="mt-2" @click="next" color="primary">บันทึก</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    UploadSingleFile,
  },
  computed: {
    moment() {
      return moment;
    },
    input() {
      return this.$store.state.input;
    },
  },
  data() {
    return {
      saveloading: false,
    };
  },
  mounted() {
    Object.assign(this.$store.state.input, this.$store.state.member);
  },
  methods: {
    async next() {
      const vm = this;
      try {
        if (await vm.$refs.observer.validate()) {
          this.$store.state.cachesImageUrl = this.input.identityNumberImage;
          this.$emit("nextstep");
        }
      } catch (error) {
        console.error(error);
        await vm.$swal.fire({
          text: error,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.titleprofile {
  color: #9f9f9f;
}

.valueprofile {
  font-size: 23px;
}
</style>
